import React from "react";
import { Divider, IconButton, InputBase, Paper, Skeleton } from "@mui/material";
import { IMAGES_PATH } from "../../constants";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FlexBox from "../../components/layouts/Flexbox";

export function ReviewReportSkeleton() {
  return (
    <React.Fragment>
      <FlexBox mb={2}>
        <FlexBox flexDirection={"column"}>
          <Skeleton variant="text" width={200} height={40} />
          <Skeleton variant="text" width={100} height={20} />
        </FlexBox>
      </FlexBox>
      <Divider />
      <Skeleton variant="rectangular" width="100%" height={60} sx={{ my: 2 }} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        sx={{ my: 2 }}
      />
      <Divider />
      <Skeleton variant="rectangular" width="100%" height={60} sx={{ my: 2 }} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        sx={{ my: 2 }}
      />
      <Divider />
      <Skeleton variant="rectangular" width="100%" height={60} sx={{ my: 2 }} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        sx={{ my: 2 }}
      />
    </React.Fragment>
  );
}

export function ErrorMessage() {
  return (
    <section className="custom-form-section">
      <div className="msg-wrapper">
        <div className="msg-block already-submit-msg">
          <img
            src={`${IMAGES_PATH}/something-went-wrong.jpg`}
            height={50}
            width={50}
          />
          <h2 style={{ color: "red", fontWeight: 500 }}>
            Oops! Something went wrong. Please try again later.
          </h2>
        </div>
      </div>
    </section>
  );
}

export function FeedbackReportLink({ url }) {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(url);
  };

  return (
    <Paper
      elevation={1}
      component="form"
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 45,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        size="small"
        fullWidth
        placeholder="Copy to clipboard"
        inputProps={{
          "aria-label": "Copy to clipboard",
          sx: { fontSize: 13 },
        }}
        readOnly
        value={url}
      />
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton
        color="primary"
        sx={{ p: "10px" }}
        aria-label="directions"
        onClick={handleCopyToClipboard}
      >
        <ContentCopyIcon />
      </IconButton>
    </Paper>
  );
}
